/**
 * アイコンサイズ定数
 *
 * DRY原則に基づき、Material Symbolsアイコンのサイズを統一的に管理。
 * プロジェクト全体でマジックナンバーを排除し、一貫性を保つ。
 */

/**
 * Material Symbolsアイコンの標準サイズ
 */
export const ICON_SIZES = {
  /** 極小: 12px - バッジ内など非常に小さい場所 */
  xs: '12px',
  /** 小: 14px - テーブルセル内、コンパクトなUI */
  sm: '14px',
  /** 中: 18px - 標準的なボタン内アイコン */
  md: '18px',
  /** 大: 20px - メニュー項目、やや大きめのボタン */
  lg: '20px',
  /** 特大: 24px - ヘッダー、目立つアイコン */
  xl: '24px',
  /** 特特大: 32px - ヒーローセクション、強調表示 */
  xxl: '32px',
} as const;

/** アイコンサイズのキー型 */
export type IconSize = keyof typeof ICON_SIZES;

/**
 * アイコンサイズ値を取得するヘルパー関数
 * @param size サイズキー
 * @returns ピクセル値の文字列
 */
export const getIconSize = (size: IconSize): string => {
  return ICON_SIZES[size];
};
